<script>
	import { onMount } from "svelte";
	import {
		FETCHING,
		FETCHED,
		NOT_FETCHING,
		routerBasepath,
	} from "../config/const.js";
	import { jwt } from "../stores/jwtstore";
	import config from "../config/config.json";
	import { DateTime } from "luxon";
	import Checkmark32 from "carbon-icons-svelte/lib/Checkmark32/Checkmark32.svelte";
	import { displaySuccessfulBookingNotif } from "../stores/displaynotification";
	import {
		DatePicker,
		DatePickerInput,
		Grid,
		Row,
		Column,
		Button,
		Loading,
		InlineNotification,
		DataTable,
		TextInput,
		Select,
		SelectItem,
		Modal,
	} from "carbon-components-svelte";
	import { navigate, Link } from "svelte-routing";
	console.log("avaialable ", routerBasepath);

	let configQueryStatus = NOT_FETCHING;
	let availableQueryStatus = NOT_FETCHING;
	let commitQueryStatus = NOT_FETCHING;
	let configQueryPromise;
	let availableQueryPromise;
	let commitQueryPromise;
	let jwt_value;
	let openModal;

	let errors = {
		date: {
			isset: false,
		},
		start_time: {
			isset: false,
		},
		end_time: {
			isset: false,
		},
		capacity: {
			isset: false,
		},
	};

	let commitQueryErrors = {
		name: {
			isset: false,
		},
		invites: {
			isset: false,
		},
		description: {
			isset: false,
		},
		commentaires: {
			isset: false,
		},
	};

	const flatpickrOptionsStart = {
		enableTime: true,
		// noCalendar: true,
		dateFormat: "H:i",
		time_24hr: true,
		element: "datepickerstart",
	};

	const flatpickrOptionsEnd = {
		enableTime: true,
		// noCalendar: true,
		dateFormat: "H:i",
		time_24hr: true,
		element: "datepickerend",
	};

	const {
		root,
		endpoints: { available, entry_handler, expose_configuration },
	} = config;

	let step, min_delay;

	let opening_hours = [];

	let times = [];

	let capacities = [];

	let query = {};

	const now = DateTime.local();

	const fetchConfig = async () => {
		let startingDay = now;
		try {
			const url = "http://" + root + expose_configuration;
			configQueryStatus = FETCHING;
			const response = await fetch(url, {
				method: "GET",
			});

			let body = await response.json();
			capacities = body.capacities;
			opening_hours = body.opening_hours;
			step = body.step;
			min_delay = body.min_delay;

			let startingDayStartTime, startingDayEndTime;
			do {
				times = [];
				let dayIndex = startingDay.toFormat("c") % 7;

				while (opening_hours[dayIndex] == "closed") {
					startingDay = startingDay.plus({ days: 1 });
					dayIndex = startingDay.toFormat("c") % 7;
				}

				const { year, month, day } = startingDay;

				const starttimes = opening_hours[dayIndex].start.split(":");
				const endtimes = opening_hours[dayIndex].end.split(":");

				startingDayStartTime = DateTime.fromObject({
					year,
					month,
					day,
					hour: starttimes[0],
					minute: starttimes[1],
				});
				startingDayEndTime = DateTime.fromObject({
					year,
					month,
					day,
					hour: endtimes[0],
					minute: endtimes[1],
				});
				startingDay = startingDay.plus({ day: 1 });
			} while (
				startingDayEndTime.plus({ minute: step * -1 }) <
				now.plus({ minute: min_delay })
			);

			let currentDate = startingDayStartTime;
			while (currentDate < startingDayEndTime) {
				let disabled =
					currentDate < now.plus({ minute: min_delay });
				times.push({
					value: currentDate,
					disabled,
				});
				currentDate = currentDate.plus({ minute: step });
			}

			const startindex = times.findIndex(
				({ value }) =>
					value > now.plus({ minute: min_delay })
			);
			if (startindex == times.length - 1) {
				console.log("there was an error", times, times.length, startindex);
			}

			query = {
				capacity: capacities[0].value,
				date: startingDayStartTime.toFormat("dd/LL/y"),
				start_time: times[startindex].value.toFormat("HH:mm"),
				end_time: times[startindex + 1].value.toFormat("HH:mm"),
			};
			configQueryStatus = FETCHED;

			if (!response.ok) {
				throw new Error();
			}
		} catch (error) {
			console.log(error);
			configQueryStatus = FETCHED;
			throw new Error(
				"Impossible de récupérer les paramères de configuration, veuillez réessayer ulterieurement"
			);
		}
	};

	onMount(() => {
		configQueryPromise = fetchConfig();
	});

	let commitQuery;

	jwt.subscribe((value) => {
		jwt_value = value;
	});

	const datechange = (e) => {
		let startingDayStartTime, startingDayEndTime;
		let startingDay = DateTime.fromJSDate(e.detail.selectedDates[0]);
		times = [];
		query.start_time = "";
		query.end_time = "";
		let dayIndex = startingDay.toFormat("c") % 7;

		while (opening_hours[dayIndex] == "closed") {
			return;
		}

		const { year, month, day } = startingDay;
		const starttimes = opening_hours[dayIndex].start.split(":");
		const endtimes = opening_hours[dayIndex].end.split(":");

		startingDayStartTime = DateTime.fromObject({
			year,
			month,
			day,
			hour: starttimes[0],
			minute: starttimes[1],
		});
		startingDayEndTime = DateTime.fromObject({
			year,
			month,
			day,
			hour: endtimes[0],
			minute: endtimes[1],
		});

		let currentDate = startingDayStartTime;
		while (currentDate < startingDayEndTime) {
			let disabled =
				currentDate < DateTime.local().plus({ minute: min_delay });
			times.push({
				value: currentDate,
				disabled,
			});
			currentDate = currentDate.plus({ minute: step });
		}

		const startindex = times.findIndex(
			({ value, disabled }) =>
				value > DateTime.local().plus({ minute: min_delay }) &&
				!disabled
		);

		if (startindex == -1) {
			times = [];
			query.start_time = "";
			query.end_time = "";
		} else {
			query.start_time = times[startindex].value.toFormat("HH:mm");
			query.end_time = times[startindex + 1].value.toFormat("HH:mm");
		}
	};

	const submitcommitrequest = async () => {
		commitQueryErrors = Object.keys(commitQueryErrors).reduce(
			(acc, val) => {
				return { ...acc, [val]: { isset: false } };
			},
			{}
		);

		const url = "http://" + root + entry_handler;

		commitQueryStatus = FETCHING;

		try {
			let commitQueryBody = {
				...commitQuery,
				jwt: jwt_value,
				start_time: Math.floor(commitQuery.start_time.toSeconds()),
				end_time: Math.floor(commitQuery.end_time.toSeconds()),
			};
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify(commitQueryBody),
			});

			let body = await response.text();
			// sur cet endpoint on a un whitespace au début du corps de la réponse
			body = body.trim();
			body = JSON.parse(body);
			if (!response.ok) {
				if (body.type === "invalid" || body.type === "missing") {
					if (commitQueryErrors[body.field]) {
						commitQueryErrors[body.field].isset = true;
						commitQueryErrors[body.field].description =
							body.description;
					}
					throw new Error("Requête invalide");
				}
				if (
					body.error.type === "QUERY" ||
					body.error.type === "DATABASE" ||
					body.error.type === "DB"
				) {
					throw new Error(body.error.description);
				}
				throw new Error("Erreur inconnue");
			}
			commitQueryStatus = FETCHED;
			if (body.valid_booking === "success") {
				displaySuccessfulBookingNotif.set(true);
				navigate("getentries");
			}
		} catch (e) {
			commitQueryStatus = FETCHED;
			if (e.name === "TypeError") {
				throw new Error("Impossible de contacter le serveur");
			}
			throw e;
		}
	};

	const getavailablerequest = async () => {
		errors = Object.keys(errors).reduce((acc, val) => {
			return { ...acc, [val]: { isset: false } };
		}, {});
		const url = "http://" + root + available;

		availableQueryStatus = FETCHING;

		try {
			query = { ...query, jwt: jwt_value };
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify(query),
			});

			let body = await response.json();

			if (!response.ok) {
				if (body.type === "invalid" || body.type === "missing") {
					if (body.field == "jwt") {
						jwt.set("");
					}
					errors[body.field].isset = true;
					errors[body.field].description = body.description;
					throw new Error("Requête invalide");
				}
				if (
					body.error.type === "QUERY" ||
					body.error.type === "DATABASE"
				) {
				}
				throw new Error(body.error.description);
			}
			availableQueryStatus = FETCHED;

			body = body.map((v, id) => {
				return {
					...v,
					start_time: new DateTime.fromSeconds(
						parseInt(v.start_time)
					),
					end_time: new DateTime.fromSeconds(parseInt(v.end_time)),
					id: id,
				};
			});
			body = body.sort(
				({ start_time: start_timeA }, { start_time: start_timeB }) => {
					return start_timeA - start_timeB;
				}
			);
			return body;
		} catch (e) {
			availableQueryStatus = FETCHED;
			if (e.name === "TypeError") {
				throw new Error("Impossible de contacter le serveur");
			}
			throw e;
		}
	};

	const formsubmit = (event) => {
		availableQueryPromise = getavailablerequest();
	};

	const closeModal = () => {
		openModal = false;
		formsubmit();
	};

	const dateDisplay = (date) => {
		return date.toLocaleString(DateTime.DATETIME_FULL);
	};

	let headers = [
		{
			key: "start_time",
			value: "Heure de début",
			display: dateDisplay,
			sort: (a, b) => {
				return a - b;
			},
		},
		{
			key: "end_time",
			value: "Heure de fin",
			display: dateDisplay,
			sort: (a, b) => {
				return a - b;
			},
		},
		{ key: "room_name", value: "Nom de la salle" },
		{ key: "buttons", empty: true },
	];
</script>

<Grid fullWidth>
	<Row padding align="center">
		<Column
			align="center"
			sm={{ span: 4, offset: 0 }}
			md={{ span: 4, offset: 2 }}
			lg={{ span: 4, offset: 7 }}
			xlg={{ span: 4, offset: 7 }}
			max={{ span: 4, offset: 7 }}
		>
			<Link to="#">Retourner à la liste des réservations</Link>
		</Column>
	</Row>

	{#if configQueryStatus != NOT_FETCHING}
		{#await configQueryPromise}
			<Loading description="Chargement de la configuration..." />
		{:then res}
			<form name="entriesform" on:submit|preventDefault={formsubmit}>
				<!--Pour le moment impossible de récupérer la valeur des deux inputs via un binding. Voir: https://github.com/IBM/carbon-components-svelte/issues/234-->
				<Row padding>
					<Column
						sm={{ span: 4, offset: 0 }}
						md={{ span: 4, offset: 2 }}
						lg={{ span: 4, offset: 7 }}
						xlg={{ span: 4, offset: 7 }}
						max={{ span: 4, offset: 7 }}
					>
						<DatePicker
							datePickerType="single"
							bind:value={query.date}
							on:change={datechange}
							dateFormat="d/m/Y"
							locale="fr"
						>
							<DatePickerInput
								bind:invalid={errors.date.isset}
								labelText="Date de la réunion"
								placeholder="dd/mm/yyyy"
							/>
						</DatePicker>
					</Column>
				</Row>
				<Row padding>
					<Column
						sm={{ span: 4, offset: 0 }}
						md={{ span: 4, offset: 2 }}
						lg={{ span: 4, offset: 7 }}
						xlg={{ span: 4, offset: 7 }}
						max={{ span: 4, offset: 7 }}
					>
						<Select
							labelText="Heure de début"
							bind:selected={query.start_time}
							bind:invalid={errors.start_time.isset}
							invalidText="La valeur entrée est invalide"
						>
							{#each times as { value, disabled }}
								<SelectItem
									value={value.toFormat("HH:mm")}
									text={value.toFormat("HH:mm")}
									{disabled}
								/>
							{/each}
						</Select>
					</Column>
				</Row>
				<Row padding>
					<Column
						sm={{ span: 4, offset: 0 }}
						md={{ span: 4, offset: 2 }}
						lg={{ span: 4, offset: 7 }}
						xlg={{ span: 4, offset: 7 }}
						max={{ span: 4, offset: 7 }}
					>
						<Select
							labelText="Heure de fin"
							bind:selected={query.end_time}
							bind:invalid={errors.start_time.isset}
							invalidText="La valeur entrée est invalide"
						>
							{#each times as { value, disabled }}
								<SelectItem
									value={value.toFormat("HH:mm")}
									text={value.toFormat("HH:mm")}
									{disabled}
								/>
							{/each}
						</Select>
					</Column>
				</Row>
				<Row padding>
					<Column
						sm={{ span: 4, offset: 0 }}
						md={{ span: 4, offset: 2 }}
						lg={{ span: 4, offset: 7 }}
						xlg={{ span: 4, offset: 7 }}
						max={{ span: 4, offset: 7 }}
					>
						<Select
							labelText="Capacité de la salle"
							bind:selected={query.capacity}
							bind:invalid={errors.capacity.isset}
							invalidText="La valeur entrée est invalide"
							bind:disabled={capacities.empty}
						>
							{#each capacities as capacity}
								<SelectItem
									value={capacity.value}
									text={capacity.text}
								/>
							{/each}
						</Select>
					</Column>
				</Row>
				<Row padding>
					<Column
						sm={{ span: 4, offset: 0 }}
						md={{ span: 4, offset: 2 }}
						lg={{ span: 8, offset: 4 }}
						xlg={{ span: 8, offset: 4 }}
						max={{ span: 8, offset: 4 }}
					>
						<Button type="submit">Chercher un créneau</Button>
					</Column>
				</Row>
			</form>
		{:catch error}
			<Row padding>
				<Column
					sm={{ span: 4, offset: 0 }}
					md={{ span: 4, offset: 2 }}
					lg={{ span: 4, offset: 7 }}
					xlg={{ span: 4, offset: 7 }}
					max={{ span: 4, offset: 7 }}
				>
					<InlineNotification
						lowContrast
						kind="error"
						subtitle={error.message}
						title="Erreur"
						hideCloseButton
					/>
				</Column>
			</Row>
		{/await}
	{/if}

	{#if availableQueryStatus != NOT_FETCHING}
		{#await availableQueryPromise}
			<Loading description="Active loading indicator" />
		{:then queryRes}
			<!--Pour le moment impossible de récupérer la valeur des deux inputs via un binding. Voir: https://github.com/IBM/carbon-components-svelte/issues/234-->
			<Row padding>
				<Column
					sm={{ span: 4, offset: 0 }}
					md={{ span: 4, offset: 2 }}
					lg={{ span: 8, offset: 4 }}
					xlg={{ span: 8, offset: 4 }}
					max={{ span: 8, offset: 4 }}
				>
					<DataTable zebra rows={queryRes} {headers} sortable>
						<span slot="cell" let:cell let:row>
							{#if cell.key === "buttons"}
								<Button
									kind="ghost"
									iconDescription="Valider"
									icon={Checkmark32}
									on:click={() => {
										commitQuery = { ...row };
										openModal = true;
									}}
								/>
								{#if openModal}
									<Modal
										preventCloseOnClickOutside
										bind:open={openModal}
										modalHeading="Faire une réservation"
										primaryButtonText="Reserver"
										secondaryButtonText="Annuler"
										on:click:button--secondary={closeModal}
										on:submit={() => {
											commitQueryPromise =
												submitcommitrequest();
										}}
									>
										<Grid fullwidth>
											<Row padding>
												<Column
													sm={{
														span: 4,
														offset: 0,
													}}
													md={{
														span: 4,
														offset: 2,
													}}
													lg={{
														span: 8,
														offset: 4,
													}}
													xlg={{
														span: 8,
														offset: 4,
													}}
													max={{
														span: 8,
														offset: 4,
													}}
												>
													<TextInput
														disabled
														labelText="Date de début"
														value={commitQuery.start_time.toFormat(
															"dd/LL/yyyy - HH:mm"
														)}
													/>
												</Column>
											</Row>
											<Row padding>
												<Column
													sm={{
														span: 4,
														offset: 0,
													}}
													md={{
														span: 4,
														offset: 2,
													}}
													lg={{
														span: 8,
														offset: 4,
													}}
													xlg={{
														span: 8,
														offset: 4,
													}}
													max={{
														span: 8,
														offset: 4,
													}}
												>
													<TextInput
														disabled
														labelText="Date de fin"
														value={commitQuery.end_time.toFormat(
															"dd/LL/yyyy - HH:mm"
														)}
													/>
												</Column>
											</Row>
											<Row padding>
												<Column
													sm={{
														span: 4,
														offset: 0,
													}}
													md={{
														span: 4,
														offset: 2,
													}}
													lg={{
														span: 8,
														offset: 4,
													}}
													xlg={{
														span: 8,
														offset: 4,
													}}
													max={{
														span: 8,
														offset: 4,
													}}
												>
													<TextInput
														labelText="Nom de la réunion"
														bind:value={commitQuery.name}
														bind:invalid={commitQueryErrors
															.name.isset}
														invalidText="La valeur entrée est invalide"
													/>
												</Column>
											</Row>
											<Row padding>
												<Column
													sm={{
														span: 4,
														offset: 0,
													}}
													md={{
														span: 4,
														offset: 2,
													}}
													lg={{
														span: 8,
														offset: 4,
													}}
													xlg={{
														span: 8,
														offset: 4,
													}}
													max={{
														span: 8,
														offset: 4,
													}}
												>
													<TextInput
														labelText="Invites"
														bind:value={commitQuery.invites}
														bind:invalid={commitQueryErrors
															.invites.isset}
														invalidText="La valeur entrée est invalide"
													/>
												</Column>
											</Row>
											<Row padding>
												<Column
													sm={{
														span: 4,
														offset: 0,
													}}
													md={{
														span: 4,
														offset: 2,
													}}
													lg={{
														span: 8,
														offset: 4,
													}}
													xlg={{
														span: 8,
														offset: 4,
													}}
													max={{
														span: 8,
														offset: 4,
													}}
												>
													<TextInput
														labelText="Description"
														bind:value={commitQuery.description}
														bind:valinvalidue={commitQueryErrors
															.description.isset}
														invalidText="La valeur entrée est invalide"
													/>
												</Column>
											</Row>
											<Row padding>
												<Column
													sm={{
														span: 4,
														offset: 0,
													}}
													md={{
														span: 4,
														offset: 2,
													}}
													lg={{
														span: 8,
														offset: 4,
													}}
													xlg={{
														span: 8,
														offset: 4,
													}}
													max={{
														span: 8,
														offset: 4,
													}}
												>
													<TextInput
														labelText="Commentaires"
														bind:value={commitQuery.commentaires}
														bind:invalid={commitQueryErrors
															.commentaires.isset}
														invalidText="La valeur entrée est invalide"
													/>
												</Column>
											</Row>
											<Row padding>
												<Column
													sm={{
														span: 4,
														offset: 0,
													}}
													md={{
														span: 4,
														offset: 2,
													}}
													lg={{
														span: 8,
														offset: 4,
													}}
													xlg={{
														span: 8,
														offset: 4,
													}}
													max={{
														span: 8,
														offset: 4,
													}}
												>
													{#if commitQueryStatus !== NOT_FETCHING}
														{#await commitQueryPromise}
															<Loading />
														{:catch error}
															<InlineNotification
																lowContrast
																kind="error"
																subtitle={error.message}
																title="Erreur"
																hideCloseButton
															/>
														{/await}
													{/if}
												</Column>
											</Row>
										</Grid>
									</Modal>
								{/if}
							{:else}
								{cell.display
									? cell.display(cell.value)
									: cell.value}
							{/if}
						</span>
					</DataTable>
				</Column>
			</Row>
		{:catch error}
			<Row padding>
				<Column
					align="center"
					sm={{ span: 4, offset: 0 }}
					md={{ span: 4, offset: 2 }}
					lg={{ span: 4, offset: 7 }}
					xlg={{ span: 4, offset: 7 }}
					max={{ span: 4, offset: 7 }}
				>
					<InlineNotification
						kind="error"
						subtitle={error.message}
						title="Erreur"
						hideCloseButton
						lowContrast
					/>
				</Column>
			</Row>
		{/await}
	{/if}
</Grid>
